var React = require('react');

function Group (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 16c0-2.2-1.8-4-4-4s-4 1.8-4 4H0c0-2.26 1.25-4.23 3.1-5.25C2.4 10.03 2 9.05 2 8c0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.06-.42 2.03-1.1 2.75.85.47 1.57 1.13 2.1 1.93 1.07-1.6 2.9-2.68 5-2.68s3.93 1.07 5 2.68c.53-.8 1.25-1.46 2.1-1.93-.7-.72-1.1-1.7-1.1-2.75 0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.06-.42 2.03-1.1 2.75 1.85 1.02 3.1 3 3.1 5.25h-2c0-2.2-1.8-4-4-4s-4 1.8-4 4c0 1.98-.96 3.74-2.44 4.83C22.2 22.13 24 24.86 24 28h-2c0-3.3-2.7-6-6-6s-6 2.7-6 6H8c0-3.14 1.8-5.86 4.44-7.17C10.96 19.73 10 17.98 10 16zm-4-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm20 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM16 20c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4z","fillRule":"evenodd"}));
}

Group.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Group;

Group.default = Group;
